<nz-drawer [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="550"
    [nzVisible]="isVisibleDrawer" [nzTitle]="'Map Supplier' + ' ' + selectedUnmappedSupplier?.supplierName" [nzFooter]="footerTpl" (nzOnClose)="handleCancel()">
    <form nz-form *nzDrawerContent [formGroup]="_fS.mapSupplierForm">
        <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24" class="section-top-padding">
            <div class="fs-20">Map with existing customer in QBO</div>
        </div>
        <div>
            <div nz-col nzSpan="24" class="section-top-padding">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="qboCustomerError">
                        <label class="label-text">Customer</label>
                        <nz-select class="select-box-width" nzShowSearch
                            nzPlaceHolder="Select Customer" formControlName="QBOCustomer" (ngModelChange)="getCustomerDetails()"
                            [nzSelectOnTab]="true">
                            <ng-container *ngIf="!isLoadingQBOCustomers">
                            <nz-option *ngFor="let option of QBOCustomersList" [nzLabel]="option.name"
                                [nzValue]="option.id"></nz-option>
                            </ng-container>
                            <nz-option *ngIf="isLoadingQBOCustomers" nzCustomContent>
                                <span nz-icon nzType="loading" class="loading-icon"></span>
                                Loading Data...
                            </nz-option>
                        </nz-select>
                        <ng-template #qboCustomerError let-control>
                            <ng-container *ngIf="control.hasError('required')">Please select QBO customer</ng-container>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div *ngIf="QBOCustomerDetail">
                <h2 class="customer-detail-text">Customer Details</h2>
                <div nz-col nzXs="24" nzSm="24" nzMd="12"
                    nzLg="12" nzXl="24" class="section-top-padding">
                    <div class="d-flex align-i-c mb-1">
                        <label class="investment-label-text">Address 1</label>
                        <p class="investment-company-name pb-0">
                            {{QBOCustomerDetail?.streetAddress1}}</p>
                    </div>
                    <div class="d-flex align-i-c mb-1">
                        <label class="investment-label-text">Address 2</label>
                        <p class="investment-company-name pb-0">
                            {{QBOCustomerDetail?.streetAddress2}}</p>
                    </div>
                    <div class="d-flex align-i-c mb-1">
                        <label class="investment-label-text">City/Town</label>
                        <p class="investment-company-name pb-0">{{QBOCustomerDetail?.city}}
                        </p>
                    </div>
                    <div class="d-flex align-i-c mb-1">
                        <label class="investment-label-text">State</label>
                        <p class="investment-company-name pb-0">{{QBOCustomerDetail?.state}}
                        </p>
                    </div>
                    <div class="d-flex align-i-c mb-1">
                        <label class="investment-label-text">Zip Code</label>
                        <p class="investment-company-name pb-0">
                            {{QBOCustomerDetail?.zipCode ? (QBOCustomerDetail?.zipCode  | mask : '00000-0000') : ''}}
                        </p>
                    </div>
                    <div class="d-flex align-i-c mb-1">
                        <label class="investment-label-text">Country</label>
                        <p class="investment-company-name pb-0">
                            {{QBOCustomerDetail?.country}}
                        </p>
                    </div>
                    <!-- <button nz-button class="addButton medium-btn mt-1" nzType="primary"
                        [nzLoading]="isLoadingOne" (click)="MapCustomerInQBO()">
                        Map
                    </button> -->
                </div>
            </div>
        </div>
    </form>
    <ng-template #footerTpl>
        <div class="d-flex justify-content-end">
            <button nz-button nzType="primary" (click)="MapCustomerInQBO()" [nzLoading]="isMappingSupplier"
                class="medium-btn small-btn width-100 mr-1">Map</button>
            <button nz-button nzType="default" (click)="handleCancel()"
                class="dlt-btn width-100">Cancel</button>
        </div>
    </ng-template>
</nz-drawer>